<template>
  <div v-if="loading" class="over container">
    <div class="row" style="height: 45vh">
      <div class="col-12"></div>
    </div>
    <div class="row">
      <div class="spinner-border text-primary center" role="status">
        <span class="sr-only"></span>
      </div>
    </div>
  </div>
  <div v-else class="container mt-0 background" style="direction: ltr;">
    <!-- *************************SHOW SPECIFIC INFO PAGE********************************* -->

    <div class="over fadeIn" id="specificInfoPage">
      <div class="row">

          <div class="col-3 text-center pt-2" @click="openPrevious">
            <div class="captionArrow">Back</div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30px"
              height="30px"
              fill="currentColor"
              class="bi bi-arrow-left"
              viewBox="0 0 16 16"
              style="bottom: 5px; position: relative"
            >
              <path
                fill-rule="evenodd"
                d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"
              />
            </svg>

          </div>

          <div
            class="text-center col-6 pe-0"
          >
          </div>
          <!-- <div
            class="col-3 text-center pt-2"
            @click="openNext"
          >
            <div class="captionArrow">Next</div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30px"
              height="30px"
              fill="currentColor"
              class="bi bi-arrow-right"
              viewBox="0 0 16 16"
              style="bottom: 5px; position: relative"
            >
              <path
                fill-rule="evenodd"
                d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
              />
            </svg>
         
          </div> -->


        <div
          class="col-12 justify-content-bottom align-self-end"
          style="
            color: grey;
            text-align: left;
            padding: 25px 35px;
            overflow: auto;
            padding: 20px 42px;
          "
        >
          <div class="title">
            Multiculturalism, Growth, and Prosperity: The Roman and Byzantine Periods          </div>

          <div class="mt-2 subTitle">
            1. Jars and funnel          </div>
          <div class="mt-2">
            Earthenware, Khirbet Nasir al-Din and Khirbet al-Nazyah, Middle Roman and Byzantine periods
          </div>

          <div class="mt-2 subTitle">
            2. Bowls, krater, and cooking pots          </div>
          <div class="mt-2">
            Earthenware, Khirbet Nasir al-Din and Mount Yeda'ya, Middle Roman and Byzantine periods
              </div>

          <div class="mt-2 subTitle">
            3. Jugs and juglets
              </div>
          <div class=" mt-2">
            Earthenware, Khirbet Nasir al-Din, Mount Yeda'ya, Tzipori, and Nazareth, Roman period
          </div>

          <div class="mt-2 subTitle">
            4. Oil lamps             </div>
          <div class=" mt-2">
            Earthenware, Nazareth and Khirbet Indur, Roman period
          </div>

          <div class="mt-2 subTitle">
            5. Dinnerware and serving utensils
                </div>
          <div class=" mt-2">
            Glass, Giv’at Katzenelson, Kafr Yasif, and Tel Shikmona, Late Roman and Byzantine periods
          </div>

          <div class="mt-2 subTitle">
            6. Jar, jug, and bowls
          </div>
          <div class=" mt-2">
            Earthenware, Tel Shikmona, Byzantine period
                  </div>

          <div class="mt-2 subTitle">
            7. Perfume vessels
                  </div>
          <div class=" mt-2">
            Earthenware and glass, Akko (Acre), Nazareth, and Yokne’am, Hellenistic to Byzantine periods
          </div>

          <div class="mt-2 subTitle">
            8. Small cosmetic bottles          </div>
          <div class=" mt-2">
            Earthenware and glass, Roman period     
          </div>

          <div class="mt-2 subTitle">
            9. Spatula and perfume spoons
          </div>
          <div class=" mt-2">
            Bone and bronze, Tel Anafa, Akko (Acre), Tel Shush, and Khirbet Indur, Roman period           </div>

           <div class="mt-2 subTitle">
            10. Buttons
          </div>
          <div class=" mt-2">
            Bone and earthenware, Tel Shikmona, Byzantine period           </div>

           <div class="mt-2 subTitle">
            11. Comb          </div>
          <div class=" mt-2">
            one, Pisgat Ze’ev, Roman period

</div>

           <div class="mt-2 subTitle">
            12. Mirrors          </div>
          <div class=" mt-2">
            Earthenware and bronze, Yokne’am and Tel Shikmona, Byzantine period
           </div>

           <div class="mt-2 subTitle">
            13. Belt buckles          </div>
          <div class=" mt-2">
            Bronze, Akko (Acre), Tel Shush, and Tel Shikmona, Roman period           </div>

           <div class="mt-2 subTitle">
            14. Key          </div>
          <div class=" mt-2">
            Bronze, Akko (Acre), Early Roman period            </div>
           <div class="mt-2 subTitle">
            15. Fibula (clasp pin for garment)          </div>
          <div class=" mt-2">
            Bronze, unknown provenance, Roman period           </div>
           <div class="mt-2 subTitle">
            16. Hairpins
          </div>
          <div class=" mt-2">
            Bone and silver, Akko (Acre), Tel Shikmona, and Meron, Roman and Byzantine period  
           </div>
           <div class="mt-2 subTitle">
            17. Bread seal
          </div>
          <div class=" mt-2">
            Earthenware, unknown provenance, Byzantine period 
           </div>
           <div class="mt-2 subTitle">
            18. Spindle weights
          </div>
          <div class=" mt-2">
            Stone and bone, Ginegar, Na’ura, and Hamat Gader, Byzantine period 
           </div>
           <div class="mt-2 subTitle">
            19. Spindle
          </div>
          <div class=" mt-2">
            Bone, Akko (Acre), Early Roman period   
           </div>
           <div class="mt-2 subTitle">
            20. Needles
          </div>
          <div class=" mt-2">
            Bone and bronze, Tel Shikmona and Akko (Acre), Hellenistic and Roman periods  
           </div>
           <div class="mt-2 subTitle">
            21. Loom weights
          </div>
          <div class=" mt-2">
            Earthenware, Bet She’an and Tiberias, Hellenistic and Roman periods    
           </div>
           <div class="mt-2 subTitle">
            22. Nails
          </div>
          <div class=" mt-2">
            Iron and bronze, Tel Anafa, Tel Kira, Meron, Akko (Acre), and Tel Shikmona, Hellenistic to Byzantine periods   
           </div>
           <div class="mt-2 subTitle">
            23. Key
          </div>
          <div class=" mt-2">
            Iron, Tel Anafa, Hellenistic period  
           </div>
           <div class="mt-2 subTitle">
            24. Key and lock
          </div>
          <div class=" mt-2">
            Bronze, Tel Shikmona, Byzantine period 
           </div>
           <div class="mt-2 subTitle">
            25. Rings
          </div>
          <div class=" mt-2">
            Bronze and iron, Ein HaShofet, Capernaum, and Tzipori, Roman period           </div>
           <div class="mt-2 subTitle">
            26. Bracelet
          </div>
          <div class=" mt-2">
            Bronze, Akko (Acre), Persian or Hellenistic period   
           </div>
           <div class="mt-2 subTitle">
            27. Miniature statue-like object
          </div>
          <div class=" mt-2">
            Bronze, Tzipori, unknown time period           
          </div>
           <div class="mt-2 subTitle">
            28. Knife
          </div>
          <div class=" mt-2">
            Iron, Tel Shikmona, unknown time period  
           </div>
           <div class="mt-2 subTitle">
            29. Item with floral design
          </div>
          <div class=" mt-2">
            Bronze, Tzipori, unknown time period    
           </div>
           <div class="mt-2 subTitle">
            30. Cymbals and sistrum (percussion instruments)
                    </div>
          <div class=" mt-2">
            Bronze, Tel Shikmona, Byzantine period   
           </div>
           <div class="mt-2 subTitle">
            31. Bells
          </div>
          <div class=" mt-2">
            Bronze, Yifat, Gvat, and Tel Shikmona, Late Roman and Byzantine periods   
           </div>
           <div class="mt-2 subTitle">
            32. Flute (recorder)
                    </div>
          <div class=" mt-2">
            Bone, Tel Shush, Roman period
           </div>

           <div class="mt-2 subTitle">
            33. Whistle
          </div>
          <div class=" mt-2">
            Earthenware, unknown provenance and time period
           </div>
           <div class="mt-2 subTitle">
            34. Seashell used as trumpet
          </div>
          <div class=" mt-2">
            Conch, Tel Shikmona, Hellenistic period  
           </div>
           <div class="mt-2 subTitle">
            35. Hoard of coins from the 1st to 3rd centuries CE
          </div>
          <div class=" mt-2">
            Bronze, Khirbet al-Majdal, Roman period
           </div>
           <div class="mt-2 subTitle">
            36. Beads
          </div>
          <div class=" mt-2">
            Glass, unknown provenance and time period   
           </div>
           <div class="mt-2 subTitle">
            37. Children’s toys and buttons
          </div>
          <div class=" mt-2">
            Various materials, various provenance, Byzantine period
           </div>
           <div class="mt-2 subTitle">
            38. Toy blocks
          </div>
          <div class=" mt-2">
            Bone, Bet She’an and Hamat Gader, Byzantine period   
           </div>
           <div class="mt-2 subTitle">
            39. Astragal and astragal-like toy
          </div>
          <div class=" mt-2">
            Bone and glass, Tel Shikmona and unknown provenance, Byzantine period   
           </div>
           <div class="mt-2 subTitle">
            40. Amulet with an engraving of harvesting farmer
          </div>
          <div class=" mt-2">
            Stone, Tiberias, unknown time period
           </div>
           <div class="mt-2 subTitle">
            41. Figurines
          </div>
          <div class=" mt-2">
            Bronze and bone, Tzipori, Bet She’an, and Tiberias, Roman period    
           </div>
           <div class="mt-2 subTitle">
            42. Figurines
          </div>
          <div class=" mt-2">
            Earthenware, Khirbet Bethsaida unknown provenance, Early Roman period   
           </div>
           <div class="mt-2 subTitle">
            43. Zoomorphic figurines
          </div>
          <div class=" mt-2">
            Earthenware, Bet She’an and unknown provenance, Roman and Byzantine periods
           </div>
           <div class="mt-2 subTitle">
            44. Door knocker
          </div>
          <div class=" mt-2">
            Bronze, Tel Shikmona, Byzantine period   
           </div>
           <div class="mt-2 subTitle">
            45. Oil lamps adorned with crosses
          </div>
          <div class=" mt-2">
            Earthenware, unknown provenance, Byzantine period    
           </div>
           <div class="mt-2 subTitle">
            46. Bread seals
          </div>
          <div class=" mt-2">
            Earthenware, , unknown provenance, Byzantine period   
           </div>
           <div class="mt-2 subTitle">
            47. Oil flask (for pouring)
          </div>
          <div class=" mt-2">
            Earthenware, Khirbet Castra, Byzantine period   
           </div>
           <div class="mt-2 subTitle">
            48. Earthenware oil lamps bearing Jewish characteristics
          </div>
          <div class=" mt-2">
            Earthenware, unknown provenance, Roman and Byzantine periods   
           </div>
           <div class="mt-2 subTitle">
            49. Amulet
          </div>
          <div class=" mt-2">
            Bronze, Kafr Kanna, Byzantine period    
           </div>
           <div class="mt-2 subTitle">
            50. Impression seal          </div>
          <div class=" mt-2">
            Stone, Horvat Butsin, Byzantine period    
           </div>
           <div class="mt-2 subTitle">
            51. Measuring cups
          </div>
          <div class=" mt-2">
            Stone, Khirbet Nasir al-Din and Masada, Roman period     
           </div>
           <div class="mt-2 subTitle">
            52. Mortar
          </div>
          <div class=" mt-2">
            Basalt stone, Daburriya, unknown time period   
           </div>
           <div class="mt-2 subTitle">
            53. Jewelry
          </div>
          <div class=" mt-2">
            Gold, glass, bronze, faience, and bone, various provenance, Roman and Byzantine periods    
           </div>
           <div class="mt-2 subTitle">
            54. Necklace
          </div>
          <div class=" mt-2">
            Gold, Tzipori, Byzantine period   
           </div>
          
           <div class="title mt-5">
            Burial        
            </div>
            <div class="mt-2 subTitle">
              1. Ossuary (casket for secondary burial)
          </div>
          <div class=" mt-2">
            Limestone, Kfar Barukh, Roman period     
           </div>
           <div class="mt-2 subTitle">
            2. Burial jar
          </div>
          <div class=" mt-2">
            Earthenware, Kfar Barukh, Roman period 
           </div>
           <div class="mt-2 subTitle">
            3. Sarcophagus (stone coffin) 
          </div>
          <div class=" mt-2">
            Limestone, fields of Kibbutz Ein Dor, Roman period
           </div>
           <div class="mt-2 subTitle">
            4. Statue head
          </div>
          <div class=" mt-2">
            Limestone, Kammaneh, Roman period   
           </div>
           <div class="mt-2 subTitle">
            5. Statue head
          </div>
          <div class=" mt-2">
            Basalt stone, fields of Kibbutz Ein Dor, Roman period   
           </div>
           <div class="mt-2 subTitle">
            6. Three mortars
          </div>
          <div class=" mt-2">
            Basalt stone, Khirbet Indur, Early Roman period    
           </div>
           <div class="mt-2 subTitle">
            7. Oil lamps
          </div>
          <div class=" mt-2">
            Earthenware, Khirbet Indur, Nein, and Na’ura, Early Roman period  
           </div>
           <div class="mt-2 subTitle">
            8. Glassware
          </div>
          <div class=" mt-2">
            Glass, Nein, Khirbet Indur, and Ginegar, Roman period    
           </div>
           <div class="mt-2 subTitle">
            9. Cauldron and firepan
          </div>
          <div class=" mt-2">
            Bronze, Kfar Kama, Roman period 
           </div>
           <div class="mt-2 subTitle">
            10. Miniature vessels
          </div>
          <div class=" mt-2">
            Nein and Khirbet Indur, Roman period    
           </div>
           <div class="mt-2 subTitle">
            11. Spindle weights
          </div>
          <div class=" mt-2">
            Limestone and basalt stone, Na’ura, Byzantine period    
           </div>
           <div class="mt-2 subTitle">
            12. Cosmetic and perfume vessels
          </div>
          <div class=" mt-2">
            Bone and bronze, Khirbet Indur and Na’ura, Roman and Byzantine periods   
           </div>
           <div class="mt-2 subTitle">
            13. Rings and beads
          </div>
          <div class=" mt-2">
            Glass, bronze, bone, and faience, Khirbet Indur, Na’ura, and Nein, Roman and Byzantine periods   
           </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Map from "./map";
export default {
  props: ["specificItemDetails"],

  // components: {
  //   Map,
  // },
  data() {
    return {
      showMainPage: true,
      style: "",
      showSpecificInfo: false,
      infoToShow: "",
      imageToShow: "",
      periodToShow: "",
      placeToShow: "",
      nameToShow: "",
      materialToShow: "",
      showMoreInfoOfItem: false,
      keyToReRenderAudio: 0,
      showMoreInformation: false,
      index: 0,
    };
  },
  mounted() {

  },
  computed: {
    loading() {
      return this.$store.getters.loading;
    },
    error() {
      return this.$store.getters.error;
    },
 
  },
  methods: {
    openNext() {
      this.$router.push({
        name: "aLaGuerre",
      });
    },
    openPrevious() {
      this.$router.push({
        name: "egyptianNeighbors",
      });
    },

    onDismissed() {
      this.$store.dispatch("clearError");
    },
  },
};
</script>

<style scoped>
.title {
  font-size: 22px;
  color: rgb(37, 37, 37);
  font-weight: bold;
}
.subTitle {
  font-size: 18px;
  color: rgb(37, 37, 37);
}
.captionArrow {
  position: absolute;
    font-size: 12px;
    top: 31px;
    left: 39px;
}
.audioButton {
  width: 100%;
  border: 2px #79a541 solid;
  border-radius: 25px;
  height: 40px;
  margin-bottom: 16px;
  position: relative;
}

.slideLeft {
  -webkit-animation: slideLeft 0.5s; /* Safari, Chrome and Opera > 12.1 */
  -moz-animation: slideLeft 0.5s; /* Firefox < 16 */
  -ms-animation: slideLeft 0.5s; /* Internet Explorer */
  -o-animation: slideLeft 0.5s; /* Opera < 12.1 */
  animation: slideLeft 0.5s;
}
.slideRight {
  -webkit-animation: slideRight 0.5s; /* Safari, Chrome and Opera > 12.1 */
  -moz-animation: slideRight 0.5s; /* Firefox < 16 */
  -ms-animation: slideRight 0.5s; /* Internet Explorer */
  -o-animation: slideRight 0.5s; /* Opera < 12.1 */
  animation: slideRight 0.5s;
}
.navBarTitle {
  position: relative;
  font-size: 22px !important;
  color: black;
  text-align: left;
  width: 100%;
  padding: 10px 18px;
}
.appBackground {
  background: url(../../static/img/appBackground.png) center center;
}
.titleSpan {
  z-index: 30;
  opacity: 1;
  padding: 10px;
  border: solid 1px white;
  width: 180px;
}
.backgroundImage {
  position: relative;
  text-align: center;
  color: white;
  font-size: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.backgroundImage::before {
  content: "";
  position: absolute;
  background-color: black;
  background-blend-mode: screen;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  opacity: 0.5;
}
.closingCross {
  position: absolute;
  top: -45px;
  right: 16px;
  z-index: 20;
  color: black;
  font-size: 24px;
}
.detectiveName {
  position: relative;
  bottom: 189px;
  width: 100%;
  text-align: center;
  margin: 0 auto;
  display: block;
}
.licenceImage {
  width: 100%;
}
.fadeIn {
  -webkit-animation: fadein 1s; /* Safari, Chrome and Opera > 12.1 */
  -moz-animation: fadein 1s; /* Firefox < 16 */
  -ms-animation: fadein 1s; /* Internet Explorer */
  -o-animation: fadein 1s; /* Opera < 12.1 */
  animation: fadein 1s;
}
.fadeOut {
  -webkit-animation: fadeOut 1s; /* Safari, Chrome and Opera > 12.1 */
  -moz-animation: fadeOut 1s; /* Firefox < 16 */
  -ms-animation: fadeOut 1s; /* Internet Explorer */
  -o-animation: fadeOut 1s; /* Opera < 12.1 */
  animation: fadeOut 1s;
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
/* Firefox < 16 */
@-moz-keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
/* Internet Explorer */
@-ms-keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
/* Opera < 12.1 */
@-o-keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
/* Firefox < 16 */
@-moz-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
/* Internet Explorer */
@-ms-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
/* Opera < 12.1 */
@-o-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideRight {
  from {
    left: 0;
  }
  to {
    left: 100vw;
  }
}
/* Firefox < 16 */
@-moz-keyframes slideRight {
  from {
    left: 0;
  }
  to {
    left: 100vw;
  }
}
/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes slideRight {
  from {
    left: 1;
  }
  to {
    left: 100vw;
  }
}
/* Internet Explorer */
@-ms-keyframes slideRight {
  from {
    left: 0;
  }
  to {
    left: 100vw;
  }
}
/* Opera < 12.1 */
@-o-keyframes slideRight {
  from {
    left: 0;
  }
  to {
    left: 100vw;
  }
}

@keyframes slideLeft {
  from {
    left: 0;
  }
  to {
    left: -100vw;
  }
}
/* Firefox < 16 */
@-moz-keyframes slideLeft {
  from {
    left: 0;
  }
  to {
    left: -100vw;
  }
}
/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes slideLeft {
  from {
    left: 0;
  }
  to {
    left: -100vw;
  }
}
/* Internet Explorer */
@-ms-keyframes slideLeft {
  from {
    left: 0;
  }
  to {
    left: -100vw;
  }
}
/* Opera < 12.1 */
@-o-keyframes slideLeft {
  from {
    left: 0;
  }
  to {
    left: -100vw;
  }
}
.imageInput {
  width: 100%;
}
.inputOnImage {
  position: absolute;
  width: 30px;
  height: 30px;
  top: 5px;
  left: 5px;
  text-align: center;
}
.topSecret {
  position: absolute;
  bottom: -30px;
  left: -37px;
  width: 248px;
}
.roundButton {
  height: 48px !important;
  width: 128px;
  border: black solid 1px;
  color: black;
  border-radius: 5px;
  background: white;
  font-size: 18px;
}
.inputSecretCode {
  width: 40px;
}
.stopButton {
  border-radius: 10px;
  background-color: rgb(183 26 5);
  margin-top: 30px;
  font-size: 24px;
  height: 50px;
  width: 50px;
  border: solid 2px white;
}
.recButton {
  border-radius: 50px;
  background-color: rgb(183 26 5);
  margin-top: 30px;
  font-size: 24px;
  height: 50px;
  width: 50px;
  border: solid 15px white;
  animation: blinker 1s linear infinite;
}
@keyframes blinker {
  50% {
    border: solid 10px white;
  }
}
.green {
  border: solid 5px #05e01c !important;
}
.image {
  width: 100%;
}
#timer {
  height: 62px;
  background: brown;
  padding-top: 11px;
  color: white;
  margin: 0;
}
.background {
  background-color: white;
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment: fixed;
}
.myModal {
  width: 320px;
  border-radius: 10px;
  display: block;
  margin: 0px auto;
  background-color: white;
}
.over {
  position: absolute;
  top: 50px;
  font-size: 18px;
  left: 0px;
  width: 100%;
  height: 100%;
  display: block;
  margin: 0px auto;
  background: white;
}
.center {
  display: block;
  margin: 0px auto;
}
.colorBtn {
  border-radius: 36px;
  min-height: 56px;
  color: white;
}
.fullWidth {
  width: 95%;
  display: block;
  margin: 0px auto;
}
.container {
  margin-top: 16px;
  font-size: 20px;
  min-height: 100vh;
}
</style>
